<script setup lang="ts">
import { onMounted } from 'vue'
import { useAuthStore } from '@/stores/auth'

const auth = useAuthStore()

onMounted(() => {
  auth.loadUser()
})
</script>

<template>
  <div id="app" class="min-h-screen bg-[#202024] text-white">
    <!-- Aquí se renderizan las páginas según la ruta -->
    <RouterView />
  </div>
</template>

<style scoped></style>